import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {BearingTask} from '@/views/system/bearingtasks/interfaces';
import {EntityModule} from './entities/entityModule';
import {getEventData, getEventTypes, getLastEvents} from '@/store/modules/entities/pmodules/base';

/*
    Динамический модуль хранилища vuex для Задач мониторинга дефектов
*/

const moduleName = 'bearingtasksStoreModule';

function transformGet(elem: any): BearingTask {
  return {
    id: elem.id,
    name: elem.name,
    description: elem.description,
    type: elem.type,
    span_node_id: elem.span_node?.id,
    deviation_before: elem.deviation_before,
    deviation_after: elem.deviation_after,
    measurements: elem.measurements
      ? elem.measurements.map((meas: any) => ({
          measurementId: meas.module_type_measurement_id,
          measurementDescription: meas.module_type_measurement_description,
          topWarningBoundary: meas.top_warning_boundary,
          topDangerBoundary: meas.top_danger_boundary,
          topErrorBoundary: meas.top_error_boundary,
          bottomWarningBoundary: meas.bottom_warning_boundary,
          bottomDangerBoundary: meas.bottom_danger_boundary,
          bottomErrorBoundary: meas.bottom_error_boundary,
        }))
      : [],
  };
}

function transformGetById(elem: any): BearingTask {
  return transformGet(elem);
}

function transformCreateEdit(elem: any): BearingTask {
  return {
    name: elem.name,
    description: elem.description,
    type: elem.type,
    span_node_id: elem.span_node?.id,
    deviation_before: elem.deviation_before,
    deviation_after: elem.deviation_after,
    measurements: elem.measurements
      ? elem.measurements.map((meas: any) => ({
          measurementId: meas.module_type_measurement_id,
          measurementDescription: meas.module_type_measurement_description,
          topWarningBoundary: meas.top_warning_boundary,
          topDangerBoundary: meas.top_danger_boundary,
          topErrorBoundary: meas.top_error_boundary,
          bottomWarningBoundary: meas.bottom_warning_boundary,
          bottomDangerBoundary: meas.bottom_danger_boundary,
          bottomErrorBoundary: meas.bottom_error_boundary,
        }))
      : [],
  };
}

function transformSave(model: BearingTask): any {
  return {
    id: model.id,
    name: model.name,
    description: model.description,
    type: model.type,
    span_node_id: model.span_node_id,
    deviation_before: model.deviation_before,
    deviation_after: model.deviation_after,
    measurements: model.measurements
      ? model.measurements.map((meas: any) => ({
          module_type_measurement_id: parseInt(meas.measurementId),
          module_type_measurement_description: meas.measurementDescription,
          top_warning_boundary: parseFloat(meas.topWarningBoundary),
          top_danger_boundary: parseFloat(meas.topDangerBoundary),
          top_error_boundary: parseFloat(meas.topErrorBoundary),
          bottom_warning_boundary: parseFloat(meas.bottomWarningBoundary),
          bottom_danger_boundary: parseFloat(meas.bottomDangerBoundary),
          bottom_error_boundary: parseFloat(meas.bottomErrorBoundary),
        }))
      : [],
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class BearingTasksStoreModule extends EntityModule {
  protected routeName = 'bearing-tasks';

  get all(): BearingTask[] {
    return super.all as BearingTask[];
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: BearingTask}> {
    return super.create(transformCreateEdit) as Promise<{data: BearingTask}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: BearingTask}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: BearingTask}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: BearingTask) {
    return super.save(model, transformSave);
  }

  //Получение объекта по идентификатору
  @Action
  async getById(id: any): Promise<{data: BearingTask}> {
    return super.getById(id, transformGetById) as Promise<{data: BearingTask}>;
  }

  //Получение типов событий
  @Action
  async getEventTypes(): Promise<any> {
    try {
      return await getEventTypes(this.routeName);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение списка последних событий
  @Action
  async getLastEvents(params: {id: number; eventType: string; limit?: number}): Promise<any> {
    try {
      return await getLastEvents(this.routeName, params);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение данных события
  @Action
  async getEventData(params: {id: number; eventType: string; timestamp: number}): Promise<any> {
    try {
      return await getEventData(this.routeName, params);
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

export default getModule(BearingTasksStoreModule);
